import {dataLayerQueryParams} from './dataLayerQueryParams.js'

export function clickUrlTransformationService({clickUrl, pageData}) {
  if (!clickUrl || !pageData) return clickUrl

  let finalUrl = clickUrl

  const freeParamsRegEx = /\$\$[a-zA-Z0-9_\-.]+\$\$/g
  const macros = finalUrl.match(freeParamsRegEx)
  if (!macros) {
    return clickUrl
  }

  for (const macro of macros) {
    const key = macro.replace(REGEXP_MACRO_DELIMITER, '')
    const value = key === DATALAYER_MACRO ? dataLayerQueryParams({pageData}) : encodeURI(pageData[key])
    finalUrl = finalUrl.replace(macro, value)
  }
  return finalUrl
}

const DATALAYER_MACRO = 'DATALAYER_PARAMS'
const REGEXP_MACRO_DELIMITER = /\$\$/g
